export default {
      id: "ic_close_box-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_close_box",
      toString: function () {
        return this.url;
      }
    }